module.exports = __webpack_public_path__ + "img/梁洼镇.af7fa0cf.png";